import { render, staticRenderFns } from "./RoleAddUserDialog.vue?vue&type=template&id=c3b4e894"
import script from "./RoleAddUserDialog.vue?vue&type=script&lang=js"
export * from "./RoleAddUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports